export const UserGuideRoutes = [
  {
    path: '/common/userGuide',
    name: 'User Guide',
    meta: {
      title: 'User Guides',
    },
    component: () => import('../views/common/UserGuide.vue'),
  },
];

export default UserGuideRoutes;
